import { qualityMessage } from "../../utils/directorFormat";

const QualityBanner = ({ flags = [], status = "available" }) => {
  const uniqueFlags = [...new Set(flags)].sort();
  if (status === "available" && uniqueFlags.length === 0) return null;
  return <aside className="director-quality" aria-label="Qualidade dos dados" role="status">
    <strong>Atenção à qualidade da leitura</strong>
    {uniqueFlags.length > 0
      ? <ul>{uniqueFlags.map((flag) => <li key={flag}>{qualityMessage(flag)}</li>)}</ul>
      : <p>A leitura possui restrições de qualidade.</p>}
  </aside>;
};

export default QualityBanner;
